export default "__VITE_ASSET__BuT2OtOs__"